var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainContent',[(_vm.activeCompany)?_c('SurveyView',{key:_vm.activeCompany._id}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }